import { Alias } from './aliases';
import { ObjectKeyMapper } from './object-key-mapper';

export class ArrayKeyMapper {
  readonly #keyMapper!: ObjectKeyMapper;

  constructor(keyMapper: ObjectKeyMapper) {
    this.#keyMapper = keyMapper;
  }

  toExternal(array: Record<string, unknown>[]): Record<string, unknown>[] {
    const rv = array.map((item) => this.#keyMapper.toExternal(item));
    return rv;
  }

  toInternal(array: Record<string, unknown>[]): Record<string, unknown>[] {
    const rv = array.map((item) => this.#keyMapper.toInternal(item));
    return rv;
  }

  // Agregar nuevas claves delegando a KeyMapper vía ObjectKeyMapper
  add(internal: string, external: string): void;
  add(alias: Alias): void;
  add(internalOrAlias: string | Alias, external?: string): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.#keyMapper.add(internalOrAlias as any, external as any);
  }
}
